import React from "react";
import ItemsHorizontalScroll from "../../shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemTmdbBtnV2 from "../../../shared/itemTmdbBtnV2/itemTmdbBtnV2";
import {Link} from "react-router-dom";
import UseSquadflixNavigate from "../useSquadflixNavigate";
import {useIntl} from "react-intl";
import SquadflixRowTitle from "../squadflixRowTitle/squadflixRowTitle";
import {useTorrestreamItemsData} from "../../hooks/useCatalogRowData";

type Props = SquadflixRowsBaseProps & {
    onMovieClick?: (item: any) => void;
    onSerieClick?: (item: any) => void;
    hasDashboardPermission?: boolean;
}

const TorrestreamItemsRow = (props: Props) => {
    const {onMovieClick, onSerieClick, hasDashboardPermission} = props;
    const {items: torrestreamItems, loading} = useTorrestreamItemsData();
    const squadflixNav = UseSquadflixNavigate({});
    const intl = useIntl();

    if (loading) return null;
    if (!torrestreamItems || torrestreamItems.length === 0) return null;
    return (
        <div style={{height: "290px", overflow: "hidden", width: "100%", order: props.order ?? 0}}>

            <SquadflixRowTitle
                {...props}
                icon={<i className="fa-solid fa-server"></i>}
                title={intl.formatMessage({id: "squadflix-home.towers-stream"})}
                extraOptions={hasDashboardPermission && (
                    <Link to="/squadflix/towersstream/dash" className="btn badge text-bg-secondary"
                          style={{border: "none"}}>
                        <small>Dashboard <i className="fa-solid fa-arrow-up-right-from-square ms-2"></i></small>
                    </Link>
                )}/>
            <ItemsHorizontalScroll>
                {torrestreamItems.map((item) => (
                    <ItemTmdbBtnV2
                        key={item.id}
                        onClick={() => {
                            if (item.isMovie) {
                                onMovieClick ? onMovieClick(item) : squadflixNav.navigateToMovie(item);
                            } else {
                                onSerieClick ? onSerieClick(item) : squadflixNav.navigateToSerie(item);
                            }
                        }}
                        bottomInfo={<>{item.vote_average.toFixed(1)}<i
                            className="fa-solid fa-star fa-sm text-warning ps-1"></i></>}
                        tmdbItem={item}
                        type={item.isMovie ? "movie" : "tv"}
                        description={item.first_air_date ?? item.release_date}
                    />
                ))}
            </ItemsHorizontalScroll>
        </div>
    );
};

export default TorrestreamItemsRow;
